iScreenWizard.factory('Testset', function ($q, Ajax) {

    var data = {};

    data.all = function() {
        return $q(function (resolve, reject) {
            Ajax.get('testset').then(function (response) {
                var testsets = response.data;
                resolve(testsets);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('testset/'+id).then(function (response) {
                var testset = response.data;
                resolve(testset);
            }, reject);
        });
    };

    return data;
});